import React from 'react';
const bonuses = [{
  title: 'Dance Class Themes™',
  description: "Une collection complète de thèmes de cours prêts à utiliser tout au long de l'année, avec des idées créatives, séquences et ateliers d'expression."
}, {
  title: 'Dance Progress System™',
  description: "Un système professionnel de suivi comprenant des fiches d'évaluation, grilles de progression et outils d'observation pour mesurer l'évolution."
}, {
  title: 'Dance Organisation Master™',
  description: 'Tous les outils nécessaires pour organiser efficacement vos cours : planifications hebdomadaires, gestion des groupes et feuilles de présence.'
}, {
  title: 'Dance Motivation Academy™',
  description: 'Activités, défis, exercices ludiques et stratégies pédagogiques pour maintenir vos élèves engagés, motivés et heureux de revenir.'
}, {
  title: 'Dance Teacher Toolbox™',
  description: 'Modèles imprimables, fiches pédagogiques, planificateurs annuels et check-lists pour simplifier votre travail au quotidien.'
}];
const benefits = [{
  emoji: '⚡',
  title: 'Gagnez des heures de préparation',
  desc: 'Ne perdez plus votre temps à créer vos cours à partir de zéro. Ouvrez le système, choisissez le cours adapté et commencez avec tout déjà prêt.'
}, {
  emoji: '👑',
  title: 'Enseignez avec plus de confiance',
  desc: 'Préparez vos cours avec une structure claire. Organisez votre enseignement de manière professionnelle et animez chaque séance avec assurance.'
}, {
  emoji: '💃',
  title: 'Faites progresser vos élèves',
  desc: 'Améliorez leur coordination, musicalité et confiance grâce à des progressions logiques qui favorisent un apprentissage durable.'
}, {
  emoji: '😊',
  title: 'Proposez des cours professionnels',
  desc: "Offrez des séances parfaitement organisées grâce à des outils pédagogiques complets qui améliorent l'expérience de vos élèves."
}];
export function BonusSection() {
  return <>
      <section className="py-8 px-4 sm:px-6 bg-brand-ivory" data-id="element-15">
        <div className="text-center mb-6" data-id="element-16">
          <h2 className="text-2xl sm:text-3xl font-heading font-bold text-brand-title mb-2 uppercase leading-tight" data-id="element-17">
            🎁 5 BONUS PREMIUM INCLUS
          </h2>
          <p className="text-sm sm:text-base text-brand-text font-medium leading-relaxed max-w-xl mx-auto" data-id="element-18">
            En plus du système principal, vous recevrez 5 bonus exclusifs
            spécialement conçus pour vous faire gagner encore plus de temps.
          </p>
        </div>

        <div className="flex flex-col gap-3 mb-6" data-id="element-19">
          {bonuses.map((bonus, i) => <div key={i} className="bg-white border-2 border-brand-gold/40 p-4 rounded-lg text-center shadow-sm" data-id="element-20">
              <p className="text-xs font-button font-bold text-brand-gold mb-1 tracking-wider uppercase" data-id="element-21">
                🎁 BONUS {i + 1} — GRATIS
              </p>
              <h3 className="text-base font-bold text-brand-title mb-1.5 leading-tight uppercase" data-id="element-22">
                {bonus.title}
              </h3>
              <p className="text-sm text-brand-text font-medium leading-relaxed" data-id="element-23">
                {bonus.description}
              </p>
            </div>)}
        </div>

        <p className="text-center font-button font-bold text-brand-rose text-sm uppercase tracking-wide bg-brand-rose/10 py-3 px-4 rounded-lg" data-id="element-24">
          Les 5 bonus sont GRATIS avec votre achat d'aujourd'hui.
        </p>
      </section>

      <section className="py-8 px-4 sm:px-6 bg-white border-t-4 border-brand-cream" data-id="element-25">
        <h2 className="text-2xl sm:text-3xl font-heading font-bold text-center text-brand-title mb-6 uppercase leading-tight" data-id="element-26">
          CE QUI VA CHANGER POUR VOUS
        </h2>

        <div className="flex flex-col gap-3" data-id="element-27">
          {benefits.map((item, i) => <div key={i} className="bg-brand-cream border-l-4 border-brand-rose p-4 rounded-r-lg shadow-sm flex gap-4 items-start" data-id="element-28">
              <div className="text-2xl shrink-0 leading-none mt-0.5" data-id="element-29">
                {item.emoji}
              </div>
              <div data-id="element-30">
                <h3 className="text-base font-bold text-brand-title mb-1 uppercase tracking-tight" data-id="element-31">
                  {item.title}
                </h3>
                <p className="text-brand-text text-sm font-medium leading-relaxed" data-id="element-32">
                  {item.desc}
                </p>
              </div>
            </div>)}
        </div>
      </section>
    </>;
}